<template>
    <div>
        <b-modal :id="'printable_form_corporate_filled'" size="xl" @shown="modalShown">
            <div class="container p-0 text-start" ref="pdfContent">
                <form class="card high-density">
                    <div class="card-body border-bottom border-black">
                        <div class="row">
                            <div class="col-md-4 col-4 d-flex align-items-center flex-column bd-highlight">
                                <img class="img-fluid img-visibility statement-logo" :src="require('@/assets/img/default_logo.png')">
                                <p class="mt-2 akkurate-green fw-bold mt-auto p-2 bd-highlight">Account Openning Form (CORPORATE)</p>
                            </div>
                            <div class="d-flex align-items-end flex-column bd-highlight col-md-8 col-8 text-end">
                                <p class="fw-bold text-uppercase mb-0">{{ institution?.name }}</p>
                                <p class="fw-bold">{{ institution?.motto }}</p>
                                <p class="mb-0 akkurate-small">{{ institution?.postal }}</p>
                                <p class="mb-0 akkurate-small">{{ institution?.telephone }}</p>
                                <p class="akkurate-small">{{ institution?.email }}</p>
                                <p class="fw-bold text-end mt-auto p-2 bd-highlight text-uppercase">{{ new
                                        Intl.DateTimeFormat('en-GB', {
                                            day: 'numeric', month: 'long', year: 'numeric'
                                        }).format(Date.now()) }}</p>
                            </div>
                        </div>
                        <!--  -->

                    </div>
                    <!-- Group Details -->
                    <div class="bg-dark text-white px-3 py-1 section-header">Corporate Details</div>
                    <div class="row g-0 border-bottom border-black">
                        <div class="col-md-6 border-end border-black p-2">
                            <label class="form-label-sm">Corporate Name</label>
                            <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form.first_name}}</p>
                        </div>
                        <div class="col-md-6 border-black p-2">
                            <label class="form-label-sm">Corporate Email</label>
                            <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form.email}}</p>
                        </div>
                    </div>
                    <div class="row g-0 border-bottom border-black">
                        <div class="col-md-4 border-end border-black p-2">
                            <label class="form-label-sm">Phone No.</label>
                            <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form.mobile}}</p>
                        </div>

                        <div class="col-md-4 border-end border-black p-2">
                            <label class="form-label-sm">Second Phone No.</label>
                            <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form.mobile_secondary}}</p>
                        </div>
                        <div class="col-md-4 border-black p-2">
                            <label class="form-label-sm">Fund Souce.</label>
                            <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form.fund_source}}</p>
                        </div>
                    </div>
                    <div class="row g-0 border-bottom border-black">
                        <div class="col-md-4 border-end border-black p-2">
                            <label class="form-label-sm">Company Regulations</label>
                            <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form.company_regulations}}</p>
                        </div>

                        <div class="col-md-4 border-end border-black p-2">
                            <label class="form-label-sm">Business Type</label>
                            <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form.business_type}}</p>
                        </div>
                        <div class="col-md-4 border-black p-2">
                            <label class="form-label-sm">TIN Number</label>
                            <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form.tin_number}}</p>
                        </div>
                    </div>

                    <div class="row g-0">
                        <div class="col-md-6 border-black border-end p-2 d-flex flex-column justify-content-center">
                            <p>Mandate</p>
                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="form.mandate=='ONLY_PRINCIPAL_SIGNATORY'" /><label class="form-check-label small">Only Principal Signatory</label></div>
                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="form.mandate=='PRINCIPAL_SIGNATORY_AND_ANY_OTHER_ONE'" /><label class="form-check-label small">Principal Signatory and Any Other</label></div>
                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="form.mandate=='ANY_OTHER_TWO_OF_THE_SIGNATORIES'" /><label class="form-check-label small">Any Other two Signatories</label></div>
                        </div>
                        <div class="col-md-6 border-black p-2 d-flex flex-column justify-content-center">
                            <p>Please Ensure the following files are attached</p>
                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="form?.passport_pic_path" /><label class="form-check-label small">Corporate Logo</label></div>
                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="form?.incorporation_certificate" /><label class="form-check-label small">Incorporation Certificate</label></div>
                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="form?.commencement_certificate" /><label class="form-check-label small">Commencement Certificate</label></div>
                        </div>
                    </div>

                    <!-- Address -->
                    <div class="bg-dark text-white px-3 py-1 section-header">Address</div>
                    <div class="row g-0 border-bottom border-black">
                        <div class="col-md-4 border-end border-black p-2">
                            <label class="form-label-sm">Address</label>
                                    <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form?.address}}</p>
                        </div>
                        <div class="col-md-4 border-end border-black p-2">
                            <label class="form-label-sm">Digital Address</label>
                                    <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form?.digital_address}}</p>
                        </div>
                        <div class="col-md-4 border-black p-2">
                            <label class="form-label-sm">Region</label>
                                    <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form?.region?.name}}</p>
                        </div>
                    </div>
                    <div class="row g-0 border-bottom border-black">
                        <div class="col-md-4 border-end border-black p-2">
                            <label class="form-label-sm">Home Town</label>
                                    <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form?.home_town}}</p>
                        </div>
                        <div class="col-md-4 border-end border-black p-2">
                            <label class="form-label-sm">Nearest Landmark</label>
                                    <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form?.nearest_landmark}}</p>
                        </div>
                        <div class="col-md-4 border-black p-2">
                            <label class="form-label-sm">Branch</label>
                                    <p class="form-control form-control-sm form-control-plaintext text-wrap">{{this.form?.branch?.name}}</p>
                        </div>
                    </div>

                    <!-- Accounts -->
                    <div class="bg-dark text-white px-3 py-1 section-header">Accounts</div>
                    <div v-for="(account,i) in this.form.accounts" class="row g-0 border-bottom border-black">
                        <div class="col-md-1 border-end border-black p-2">
                            <h5 class="m-0 p-0 fw-bold">{{ i+1 }}</h5>
                            <!-- <label class="form-label-sm">Account Type</label> -->
                            <!-- <input disabled class="form-control form-control-sm form-control-plaintext" type="text" /> -->
                        </div>
                        <div class="col-md-6 border-end border-black p-2">
                            <label class="form-label-sm">Account Type</label>
                                    <p class="form-control form-control-sm form-control-plaintext text-wrap">{{account.account_type.name}}</p>
                        </div>
                        <div class="col-md-5 border-black p-2">
                            <label class="form-label-sm">Balance</label>
                                    <p class="form-control form-control-sm form-control-plaintext text-wrap">{{account.account_balance}}</p>
                        </div>
                    </div>
                    
                    <!-- Signatory Details -->
                    <div class="bg-dark text-white px-3 py-1 section-header">Signatories</div>
                    <div class="" v-for="(signatory,i) in this.form.signatories">
                        <div class="d-flex g-0 p-0 ">
                            <div class="row flex-grow g-0 border-end border-bottom border-black p-0">
                                <div class="row col-md-12 p-0 g-0 border-bottom border-black">
                                    <div class="col-md-1 border-end border-black p-2 d-flex flex-column justify-content-center">
                                        <!-- <label class="form-label-sm mb-2">Title</label>
                                        <div class="d-flex flex-wrap gap-2">
                                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" /><label class="form-check-label small">Mr.</label></div>
                                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" /><label class="form-check-label small">Ms.</label></div>
                                        </div> -->
                                        <h5 class="m-0 p-0 fw-bold">{{ i+1 }}</h5>
                                    </div>
                                    <div class="col-md-6 border-end border-black p-2">
                                        <label class="form-label-sm">Name</label>
                                        <p class="form-control form-control-sm form-control-plaintext text-wrap">{{signatory?.name}}</p>
                                    </div>
                                    <div class="col-md-5 border-black p-2">
                                        <label class="form-label-sm">Position</label>
                                        <p class="form-control form-control-sm form-control-plaintext text-wrap">{{signatory?.position}}</p>
                                    </div>
                                </div>
                                <div class="row col-md-12 p-0 g-0 border-bottom border-black">
                                    <div class="col-md-7 border-end border-black p-2 d-flex flex-column justify-content-center">
                                        <label class="form-label-sm mb-2">Id Type</label>
                                        <div class="d-flex flex-wrap gap-3">
                                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="signatory?.id_type=='Ghana Card'" /><label class="form-check-label small">Ghana Card</label></div>
                                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="signatory?.id_type=='Passport'" /><label class="form-check-label small">Passport</label></div>
                                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="signatory?.id_type=='Voters ID'" /><label class="form-check-label small">Voters ID</label></div>
                                        </div>
                                    </div>


                                    <div class="col-md-5 p-2">
                                        <label class="form-label-sm">Id Number</label>
                                        <p class="form-control form-control-sm form-control-plaintext text-wrap">{{signatory?.id_number}}</p>
                                    </div>

                                </div>
                                <!-- Gender -->
                                <div class="col-md-12 p-2 border-black">
                                    <label class="form-label-sm mb-2">Signatory Type</label>
                                    <div class="d-flex flex-wrap gap-3">
                                        <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="signatory?.signatory_type == 'PRINCIPAL'" /><label class="form-check-label small">PRINCIPAL</label></div>
                                        <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="signatory?.signatory_type == 'OTHERS'" /><label class="form-check-label small">OTHERS</label></div>
                                    </div>
                                </div>

                            </div>
                            
                            <div class="border-bottom border-black border-black flex items-center justify-center p-2 bg-zinc-50 dark:bg-zinc-900/50">
                                <div class="passport-photo-box">
                                    <img class="leading-tight tracking-tighter imgPos" v-if="signatory?.profile_photo" :src="signatory?.profile_photo" :alt="'Profile'" >
                                    <span v-else class="text-[9px] font-bold text-zinc-400 uppercase leading-tight tracking-tighter">Attach Passport Photo Here</span>
                                </div>
                            </div>
                        </div>
                        <div class="row g-0 border-bottom border-black">
                            <div class="col-md-7 border-end border-black p-2 d-flex flex-column justify-content-center">
                                <p>Please Ensure the following files are attached</p>
                                <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="signatory?.profile_photo" /><label class="form-check-label small">Passport Picture</label></div>
                                <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="signatory.ghana_card_back && signatory.ghana_card_front" /><label class="form-check-label small">The Selected Card Copy (Front and Back)</label></div>
                            </div>
                            <div class="col-md-5 border-black p-2">
                                <label class="form-label-sm">Signature</label>
                                <!-- <input disabled class="form-control form-control-sm form-control-plaintext" type="text" /> -->
                            </div>
                        </div>

                    </div>

                    <!-- Account Priority Type -->
                    <div class="bg-dark text-white px-3 py-1 section-header">Account Priority Type</div>
                    <div class="col g-0 border-bottom border-black">
                        <div class="p-2">
                            <p class="m-0 p-0">Priority Type - Note</p>
                            <div class="form-check me-3"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="this.form.customer_category == 'standard'" /><label class="form-check-label small">STANDARD — Available to all user roles.</label></div>
                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="this.form.customer_category == 'premium'" /><label class="form-check-label small">PREMIUM — Restricted for Mobile Bankers, Tellers, and Front Desk staff.</label></div>
                            <div class="form-check"><input disabled class="form-check-input disabled border-black" type="checkbox" :checked="this.form.customer_category == 'executive'" /><label class="form-check-label small">EXECUTIVE — Restricted to the General Manager, Accountant, and Board Chairman only.</label></div>
                        </div>
                    </div>
                </form>
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <!-- begin loader -->
                    <!-- <beat-loader-component class="float-left" v-if="isLoading"
                        :isLoading="isLoading"></beat-loader-component> -->
                    <!-- end loader -->
                    <!-- Emulate built in modal footer ok and cancel button actions -->
                    <b-button @click="printPDF" type="button" class="akkurate-green-btn download-btn ms-2 float-right"><span class="small"><font-awesome-icon :icon="['fas', 'book']" />Print</span></b-button>
                    <b-button @click="downloadPDF" class="akkurate-green-btn download-btn float-right"><span class="small"><font-awesome-icon :icon="['fas', 'save']" /> Download</span></b-button>
                </div>
            </template>

        </b-modal>
    </div>
</template>
<script>
import ApiService from "@/core/services/api.service";
import html2pdf from "html2pdf.js";
export default {

    props: ['form','files'],
    components: {
    },
    oncreated() {
        // this.getAccountStatement();
        this.getMember();
    },
    data() {
        return {
            member: null,
            institution: {},
            filter: {
                account_number: "",
                start_date: this.getOneMonthBeforeDate(),
                end_date: new Date().toISOString().substr(0, 10),
            },
            frontImgUrl: "",
            backImgUrl: "",
            imageLoaded: false,
            rewrtieLoading: false,
            total_credit: 0,
            total_debit: 0,
            fields: [
                { key: 'trans_date', label: 'Date' },
                { key: 'reference', label: 'Reference' },
                { key: 'transaction_mode', label: 'Mode' },
                { key: 'trans_status', label: 'Status' },
                // { key: 'code', label: 'Trans. ID' },
                { key: 'narration', label: 'Description' },
                { key: 'debit', label: 'Debit' },
                { key: 'credit', label: 'Credit' },
                { key: 'previous_balance', label: 'Prev.Balance' },
                { key: 'current_balance', label: 'Balance' },
                // { key: 'teller', label: 'Teller' },
            ],
            loanFields: [
                {
					key: "trans_date",
					label: "Date",
				},

				{
					key: "description",
					label: "Description",
				},
				{
					key: "debit",
					label: "Debit",
				},
				{
					key: "credit",
					label: "Credit",
				},

				{
					key: "previous_balance",
					label: "Prev.BAL",
				},
				{
					key: "principal",
					label: "Principal Paid",
				},
				{
					key: "principal_balance",
					label: "Principal balance",
				},
				{
					key: "interest",
					label: "Interest Paid",
				},
				{
					key: "interest_balance",
					label: "Interest balance",
				},
            ]
            ,
            items: [],
            search: "Search",
            isSearching: false,
            isBusy: false,
            isLoading: false,
        }
    },
    computed: {
        
    },
    mounted() {
        this.getInsistution();
    },
    methods: {
        async getInsistution() {
            await ApiService.get('/settings/institution').then((response) => {
                // console.log(response);
                this.institution = response.data.data;
            }).catch((error) => {
                // console.log(error);
            })
        },
        handleImageLoad() {
            this.imageLoaded = true;
            this.frontImgUrl = this.details.account?.customer?.gh_card_front_path;
            this.backImgUrl = this.details.account?.customer?.gh_card_back_path;
        },
        downloadPDF() {
            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            // console.log("here");
            const pdfOptions = {
                margin: [0.1, 0.1, 1.0, 0.1],
                filename: 'statement.pdf',
                image: { type: 'jpeg', quality: 1.0 },
                html2canvas: { scale: 4, useCORS: true, letterRendering: true },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
                pagebreak: {
                    mode: ['css', 'legacy']
                }
            };
            html2pdf()
                .from(content)
                .set(pdfOptions)
                .toPdf()
                .get('pdf')
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;

                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(["For Inquiries, Please Contact " + insit_name + ", Customer Service on " + insit_tele + "", "or email us on " + insit_email + " " + insit_motto + "", "Page " + i + " of " + totalPages], pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 0.6, { align: "center" });
                    }
                }).save();

        },
        printPDF() {
            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            // console.log("here");
            const pdfOptions = {
                margin: [0.1, 0.1, 1.02, 0.1],
                filename: 'statement.pdf',
                image: { type: 'jpeg', quality: 1.0 },
                html2canvas: { scale: 4, useCORS: true, letterRendering: true },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
                pagebreak: {
                    mode: ['css', 'legacy']
                }
            };
            html2pdf()
                .from(content)
                .set(pdfOptions)
                .toPdf()
                .get('pdf')
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;
                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(["For Inquiries, Please Contact " + insit_name + ", Customer Service on " + insit_tele + "", "or email us on " + insit_email + " " + insit_motto + "", "Page " + i + " of " + totalPages], pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 0.6, { align: "center" });
                    }
                    // Get the blob of the PDF
                    return pdf.output("blob");
                })
                .then((pdfBlob) => {
                    // Create a URL for the PDF blob
                    var pdfUrl = URL.createObjectURL(pdfBlob);

                    // Open the URL in a new tab
                    const printWindow = window.open(pdfUrl, '_blank', 'width=800,height=600');
                    printWindow.onload = () => {
                        printWindow.print();
                        URL.revokeObjectURL(pdfUrl);
                    };
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                });
        },
        filterAccountStatement() {
            this.getAccountStatement();
        },
        modalShown() {
            // this.getAccountStatement();
            // this.getMember();
            console.log('Form',this.form);
        },
        getOneMonthBeforeDate() {
            // Get today's date
            let currentDate = new Date();

            // Remove one month to the current date
            currentDate.setMonth(currentDate.getMonth() - 1);

            // Format the date as 'YYYY-MM-DD'
            return currentDate.toISOString().substr(0, 10);
        },
        async refreshLoanTransactions(customer_id) {
            console.log(this.data)
            this.rewrtieLoading = true
            console.log(customer_id);
            await ApiService.post(`/transactions/rewrite`, {
                'customer_id': customer_id
            }).then((response) => {
                this.isLoadingSaving = false;
                this.$Progress.finish();
                toast.fire({
                    icon: "success",
                    title: response.data.message,
                });
                this.isSaving = false;
                this.filterAccountStatement();
                this.rewrtieLoading = false;
            }).catch((error) => {
                this.isSaving = false;
                this.$Progress.fail();
                if (error.response.data.errors) {
                    this.form.errors = error.response?.data?.errors;
                }
                this.rewrtieLoading = false;
            });
        },


    }
}
</script>

<style scoped>
    :root {
        --bs-body-font-size: 0.875rem;
    }

    body {
        background-color: #f8f9fa;
    }

    .passport-photo-box {
        width: 2in;
        height: 2in;
        border: 2px dashed #94a3b8;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 5px;
    }

    .material-symbols-outlined {
        vertical-align: middle;
        font-size: 1.25rem;
    }

    .section-header {
        font-size: 0.75rem;
        letter-spacing: 0.05rem;
        text-transform: uppercase;
        font-weight: 700;
    }

    .form-label-sm {
        font-size: 0.65rem;
        font-weight: 600;
        text-transform: uppercase;
        margin-bottom: 0.1rem;
        display: block;
        color: #495057;
    }

    .form-control-plaintext {
        padding: 0;
        font-size: 0.9rem;
        border-bottom: 1px solid #dee2e6 !important;
    }

    .form-control-plaintext:focus {
        outline: none;
        border-bottom-color: #0d6efd !important;
    }

    .card {
        border-radius: 0;
        border: 1px solid #000;
    }

    .border-black {
        border-color: #000 !important;
    }

    .high-density .col,
    .high-density [class*="col-"] {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .logo-box {
        border: 3px solid #000;
        width: 80px;
        height: 80px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        line-height: 1;
    }

    @media print {
        .no-print {
            display: none !important;
        }

        body {
            background-color: white !important;
            padding: 0 !important;
        }

        .container {
            max-width: 100% !important;
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
        }

        .card {
            border: 1px solid #000 !important;
            box-shadow: none !important;
        }

        .bg-dark {
            background-color: #000 !important;
            -webkit-print-color-adjust: exact;
        }

        .text-white {
            color: #fff !important;
            -webkit-print-color-adjust: exact;
        }
    }

    .form-control:disabled,
        .form-control[readonly] {
            background-color: #fff;
            opacity: 1;
            color: #000 !important;
        }

    .imgPos{
        width: 100%;
        height: auto;
        max-height: 150px;
        object-fit: contain;
    }
</style>